import { Component, OnInit, Injector, ViewChild, Input }  from '@angular/core';
import { UserService }                  from '../_service/user.service';
import User                             from '../models/User';
import { LoggedBaseComponent }          from '../_components/LoggedBaseComponent';
import { NavigationEnd }                from '@angular/router';
import { filter }                       from 'rxjs/operators';
import ObjectList                       from '../models/ObjectList';
import MenuItem                         from '../models/MenuItem';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  providers : [UserService],
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent extends LoggedBaseComponent implements OnInit {

  menu_item_list  : ObjectList<MenuItem> = new ObjectList<MenuItem>();
  current_user    = new User({"username" : "No One"});
  activeRoute     = {};
  
  @ViewChild('sidenav', {static: false}) public menu_sidenav: MatSidenav;
  
  constructor(injector : Injector)
  { 
    super(injector);
    this._router.events.pipe(filter(event => event instanceof NavigationEnd)  
    ).subscribe((event: NavigationEnd) => {
      this.activeRoute = event.url.replace("/","");
    });
  }
  
  toggleMenu(value)
  {

    if (this.menu_sidenav !== undefined)
    {
      if (value)
      {
        this.menu_sidenav.open();
      }
      else
      {
        this.menu_sidenav.close();  
      }
    }
  }

  goThere(router_link)
  {
    this.menu_sidenav.close();
    this._router.navigate([ router_link ]);
  }

  ngOnInit() 
  {
      this._eventEmitterService.getEventEmitter("side_menu").subscribe(function(value) {
          this.toggleMenu(value);
      }.bind(this));
    
      if (this.isSuperUser())
      {
        this.menu_item_list.push(new MenuItem({ "reference_name": "admin", "link": "dashboard/admin", "icon": "settings" }), "reference_name");
      }
      

      
    

    //  this._sessionStorageService.getWatcher("user_info").subscribe((nextValue) => {
    //       //Removing FILE MANAGER SECTION from MENU if the user doesn't have permission (user not in file_manager group)
    //       let user_info     = this._sessionStorageService.getWatchedSessionStorage("user_info");
    //       if (user_info !== undefined  && user_info !== null)
    //       {
    //         let parsed_user_info    = JSON.parse(user_info);
    //         this.current_user       = new User(parsed_user_info);
    //       }
          
    //   });

  }

}
